function isAmbiguous(_ref) {
  let result = _ref.result;
  return result.length > 1;
}

module.exports = isAmbiguous;